import api from "./api";
import { API_ENDPOINTS } from "../utils/constants";

export const askAiService = {
  getConfig: async () => {
    const response = await api.get(API_ENDPOINTS.ASKAI.CONFIG);
    return response.data;
  },
  listConversations: async (params = {}) => {
    const response = await api.get(API_ENDPOINTS.ASKAI.CONVERSATIONS, { params });
    return response.data;
  },
  createConversation: async (title = "") => {
    const response = await api.post(API_ENDPOINTS.ASKAI.CONVERSATIONS, { title });
    return response.data;
  },
  getConversation: async (conversationId) => {
    const response = await api.get(API_ENDPOINTS.ASKAI.CONVERSATION_DETAIL(conversationId));
    return response.data;
  },
  renameConversation: async (conversationId, title) => {
    const response = await api.patch(API_ENDPOINTS.ASKAI.CONVERSATION_DETAIL(conversationId), { title });
    return response.data;
  },
  archiveConversation: async (conversationId) => {
    await api.delete(API_ENDPOINTS.ASKAI.CONVERSATION_DETAIL(conversationId));
  },
  listMessages: async (conversationId, params = {}) => {
    const response = await api.get(API_ENDPOINTS.ASKAI.MESSAGES(conversationId), { params });
    return response.data;
  },
  // Returns as soon as the message rows exist — the actual plan/narrate
  // work (two provider calls against a shared, sometimes-slow LAN box)
  // runs on Celery, not inline in this request, so this no longer needs
  // the app-wide axios timeout overridden. See getMessage for polling the
  // real answer.
  sendMessage: async (conversationId, content, pageContext) => {
    const payload = pageContext ? { content, page_context: pageContext } : { content };
    const response = await api.post(API_ENDPOINTS.ASKAI.MESSAGES(conversationId), payload);
    return response.data;
  },
  // Re-runs one failed answer in place. Retry used to be a plain
  // resend, which left the failed bubble, the original question, and a
  // duplicate of that question all in the thread; this reuses the same
  // message row, so the client also keeps polling the id it already has.
  retryMessage: async (conversationId, messageId) => {
    const response = await api.post(API_ENDPOINTS.ASKAI.MESSAGE_RETRY(conversationId, messageId));
    return response.data;
  },
  // Stops waiting for an answer. The server marks the row cancelled
  // and revokes the queued task; an answer already in flight is not
  // killed, but its result is discarded rather than reappearing.
  cancelMessage: async (conversationId, messageId) => {
    const response = await api.post(API_ENDPOINTS.ASKAI.MESSAGE_CANCEL(conversationId, messageId));
    return response.data;
  },
  getMessage: async (conversationId, messageId) => {
    const response = await api.get(API_ENDPOINTS.ASKAI.MESSAGE_DETAIL(conversationId, messageId));
    return response.data;
  },
  getRoleAccess: async () => {
    const response = await api.get(API_ENDPOINTS.ASKAI.ROLE_ACCESS);
    return response.data;
  },
  updateRoleAccess: async (updates) => {
    const response = await api.patch(API_ENDPOINTS.ASKAI.ROLE_ACCESS, updates);
    return response.data;
  },
};

export default askAiService;
